<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()"
  [closable]="true">
  <ng-template pTemplate="header">
    <span class="upload-files-header">Upload Products</span>
  </ng-template>

  <ng-template pTemplate="body">
    <div class="upload-container">
      <div class="mb-3 upload-accepted-label">
        Accepted Files: .xlsx, .xls, .csv (Maximum size: 10MB)
      </div>

      <p-fileUpload
        #fileUpload
        mode="advanced"
        [auto]="false"
        [multiple]="false"
        accept=".xlsx,.xls,.csv"
        [maxFileSize]="maxFileSize"
        [fileLimit]="1"
        chooseLabel="Choose File"
        cancelLabel="Cancel"
        [showUploadButton]="false"
        [showCancelButton]="false"
        [customUpload]="true"
        (onSelect)="onFileSelect($event)"
        (onClear)="onFileClear()"
        (onRemove)="onFileRemove($event)"
        (onError)="onError($event)"
        [styleClass]="'upload-file-component'">
      </p-fileUpload>

      <div class="error-message mt-3" *ngIf="errorMessage">
        <i class="pi pi-exclamation-triangle mr-2"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <div class="file-info mt-3" *ngIf="uploadedFile && !errorMessage">
        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center">
            <i class="pi pi-file mr-2"></i>
            <span class="file-name">{{ uploadedFile.name }}</span>
            <span class="file-size ml-2">({{ getFileSizeString(uploadedFile.size) }})</span>
          </div>
          <p-button
            icon="pi pi-times"
            [text]="true"
            [rounded]="true"
            severity="secondary"
            (click)="clearFile()"
            pTooltip="Remove file"
            tooltipPosition="top">
          </p-button>
        </div>
      </div>

      <div class="upload-hint mt-3">
        <p class="text-small">
          <i class="pi pi-info-circle mr-2"></i>
          Drag and drop your file here or click "Choose File" to browse.
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        [outlined]="true"
        (click)="closeDialog()"
        [disabled]="isUploading">
      </p-button>
      <p-button
        label="Upload"
        (click)="uploadFile()"
        [disabled]="!uploadedFile || !!errorMessage || isUploading"
        [loading]="isUploading">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

